export function parseValidationErrors(errorResponse) {
    if (!errorResponse.error)
        return [];
    try {
        // The error field contains a JSON string of validation errors
        const errors = JSON.parse(errorResponse.error);
        // Ensure it's an array
        if (Array.isArray(errors)) {
            return errors.filter(error => error &&
                typeof error === 'object' &&
                error.Title &&
                error.Message);
        }
        return [];
    }
    catch (e) {
        // If parsing fails, return the raw error as a single validation error
        return [{
                Title: 'Error',
                Message: errorResponse.error
            }];
    }
}
export function isValidationError(statusCode) {
    return statusCode === 422;
}
/**
 * Sets React Hook Form errors from validation errors.
 * The FieldName property of each validation error should match the form field name.
 *
 * @param errorResponse - The API error response containing validation errors
 * @param setError - The setError function from React Hook Form
 * @returns true if validation errors were set, false otherwise
 */
export function setFormValidationErrors(errorResponse, setError) {
    if (errorResponse.status !== 422)
        return false;
    const validationErrors = parseValidationErrors(errorResponse);
    if (validationErrors.length === 0)
        return false;
    let isFirstError = true;
    validationErrors.forEach(error => {
        if (error.FieldName) {
            // Set the error for the field matching the FieldName
            // Focus on the first field with an error
            setError(error.FieldName, {
                type: 'server',
                message: error.Message
            }, {
                shouldFocus: isFirstError
            });
            isFirstError = false;
        }
    });
    return true;
}
export function handleApiError(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, showError, _showValidationErrors, defaultTitle = 'Operation Failed') {
    console.error('API Error:', error);
    // Check if it's a validation error (422) or forbidden (403)
    // Note: The global error handler already shows toasts for these,
    // so we skip showing them here to avoid duplicates
    if (error.status === 422 || isValidationError(error.status)) {
        return;
    }
    if (error.status === 403) {
        return;
    }
    // Handle other error types
    if (error.error) {
        showError(defaultTitle, error.error);
    }
    else if (error.message) {
        showError(defaultTitle, error.message);
    }
    else if (typeof error === 'string') {
        showError(defaultTitle, error);
    }
    else {
        showError(defaultTitle, 'An unexpected error occurred. Please try again.');
    }
}
